import { Avatar, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { PurplePdfDocument } from 'Images';

interface ITitle {
  docName: string;
}

export const Title = ({ docName }: ITitle) => {
  return (
    <Stack>
      <Typography variant='body6'>
        {Dictionary[DICTIONARY.Documents].docName}
      </Typography>
      <Stack direction='row' alignItems='center' gap='4px'>
        <Avatar
          alt=''
          src={PurplePdfDocument}
          sx={{ width: '20px', height: '20px' }}
        />
        <Typography variant='body1'>{docName}</Typography>
      </Stack>
    </Stack>
  );
};
